import { render, staticRenderFns } from "./productcenterzyjy.vue?vue&type=template&id=b7c8b90e&scoped=true&"
import script from "./productcenterzyjy.vue?vue&type=script&lang=js&"
export * from "./productcenterzyjy.vue?vue&type=script&lang=js&"
import style0 from "./productcenterzyjy.vue?vue&type=style&index=0&id=b7c8b90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c8b90e",
  null
  
)

export default component.exports